import {SUCCESS_API_CALL} from "../constants/action-types";
import {any} from "prop-types";

const initialState = {
    data:any
};

const waitingReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SUCCESS_API_CALL:{
            return {
                ...state,
                data: action.data,
                loading:false
            };
        }
        default:
            return state;
    }
};

export default waitingReducer;
